<template>
    <b-sidebar :visible="false" :id="id" :title='$t("lbl_EMPBE_NewsInfoCenter")'  right bg-variant="white" @shown="scrollToAdPosition" :shadow="true" backdrop>
        <div class="tab-pane active">
            <div class="card shadow-none">
                <div class="card-body">
                    <img :src="'https://cdn.adsalecdn.com/EMP/Backend/Images/' + langid + '/emp_homepage_news.jpg'" width="100%" />

                </div>
            </div>
        </div>
    </b-sidebar>

</template>
<script>
export default {
    props: ["id"],
    computed: {
        langid() {
            return localStorage.getItem("currentLangId")
        }
    },
    methods: {
        scrollToAdPosition() {
            this.$el.children[1].lastElementChild.scrollTo({
                top: 1200,
                left: 0,
                behavior: 'smooth'
            });
        }
    }

}
</script>